const mutations = {
  sessionInit (state) {
    state.loginStatus = true
    state.user.uuid = sessionStorage.getItem('uuid')
    state.user.token = sessionStorage.getItem('token')
    state.user.name = sessionStorage.getItem('name')
    state.user.schoolName = sessionStorage.getItem('schoolName')
    state.user.balances = sessionStorage.getItem('balances')
  },
  roleListInit (state) {
    state.roleList = JSON.parse(sessionStorage.getItem('roleList'))
  },
  roleInit (state) {
    state.role = JSON.parse(sessionStorage.getItem('role'))
    state.permission = sessionStorage.getItem('menu')
  },
  permissionInit (state, obj) {
    state.mapPermission = obj;
  },
  pagePermissionInit (state, array) {
    state.pagePermission = array;
  },
  sessionMiss (state, msg) {
    state.loginStatus = false
    state.loginErrorMsg = msg
    state.user.token = ''
    sessionStorage.clear()
  },
  roleMiss (state) {
    sessionStorage.removeItem('role')
    sessionStorage.removeItem('menu')
    state.role = null
    state.permission = null
  },
  distoryErrorDialog (state) {
    state.dialogErrorMessage.show = false;
  },
  showErrorMsg (state, {errMsg, url}) {
    state.dialogErrorMessage.content = errMsg
    state.dialogErrorMessage.errorUrl = url
    state.dialogErrorMessage.show = true
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js